<template>
    <div v-if="!loading" id="article-details">
        <!-- Article Card (summary) -->
        <article-card :article="article" class="article-details__card" />

        <!-- Tags Card -->
        <article-tags-card :article="article" class="article-details__card" />

        <!-- Supplements Card -->
        <article-supplements-card
            v-if="article.type !== $const.articles.type.SUPPLEMENT"
            :article="article"
            class="article-details__card"
        />

        <!-- Article Description Card -->
        <article-description-card :article="article" />

        <!-- Article Properties Card -->
        <article-properties-card
            :article="article"
            class="article-details__card"
        />

        <!-- Article Photo Card -->
        <article-photo-card
            :article="article"
            class="article-details__card"
        />

        <!-- Article Pack Contents Card -->
        <article-pack-contents-card
            v-if="article.type === $const.articles.type.PACK"
            :article="article"
            class="article-details__card"
        />

        <div class="clear-both"></div>
    </div>

    <div v-else class="text-center">
        <img src="/img/loader-761.svg" alt="Loading..." class="inline">
    </div>
</template>

<script setup>
import { computed, onBeforeMount, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import ArticleCard from '@/components/articles/ArticleCard.vue';
import ArticleTagsCard from '@/components/articles/ArticleTagsCard.vue';
import ArticleSupplementsCard from '@/components/articles/ArticleSupplementsCard.vue';
import ArticlePropertiesCard from '@/components/articles/ArticlePropertiesCard.vue';
import ArticlePhotoCard from '@/components/articles/ArticlePhotoCard.vue';
import ArticleDescriptionCard from '@/components/articles/ArticleDescriptionCard.vue';
import ArticlePackContentsCard from '@/components/articles/ArticlePackContentsCard.vue';

const emit = defineEmits(['loading', 'loaded']);

const store = useStore();
const route = useRoute();

const loading = ref(true);

const article = computed(() => store.state.articles.cArticle);

async function initialize()
{
    // Load the article details
    loading.value = true;
    const articleId = route.params.article_id;
    emit('loading');

    try
    {
        const article = await store.dispatch('articles/fetchArticle', articleId);

        // Select the article for display
        await store.dispatch('articles/setCurrentArticle', article);
    }
    catch(error)
    {
        console.error('could not fetch article', { articleId, error });
        throw error;
    }
    finally
    {
        loading.value = false;
        emit('loaded');
    }
}

watch(() => route.params.article_id, async articleId =>
{
    if(parseInt(articleId))
    {
        await initialize();
    }
});

onBeforeMount(async() =>
{
    await initialize();
});
</script>

<style lang="css">
@reference "@/assets/styles/main.css";

#article-details
{
    @apply columns-1 lg:columns-2 3xl:columns-3;

    & .cs-card
    {
        @apply mb-4;

        & .no-content
        {
            @apply text-gray-400 italic;
        }
    }
}
</style>
